import { Component, OnInit } from '@angular/core';
import { ThemingService } from 'src/app/theming.service';
import { AuthService } from 'src/app/auth.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-chat-app',
  templateUrl: './chat-app.component.html',
  styleUrls: ['./chat-app.component.scss']
})
export class ChatAppComponent implements OnInit {
  userDetails: any;
  shopId: string = '';
  shopGuid: string = '';
  userEmail: string | null = null;
  private emailSubscription!: Subscription;
  private chatAppBaseUrl: string = environment.chatAppBaseUrl;

  constructor(public themingService: ThemingService, private authService: AuthService) { }

  async ngOnInit() {
    this.userDetails = await this.authService.getCurrentUserDetails();

    this.emailSubscription = this.authService.userEmail$.subscribe((email) => {
      this.userEmail = email;
    });

    this.userEmail = this.authService.getCurrentUserEmail();

    if (this.themingService && this.themingService.shopId) {
      this.shopId = this.themingService.shopId.toString();
    }
    if (this.themingService && this.themingService.shopGuid) {
      this.shopGuid = this.themingService.shopGuid.toString();
    }
  }

  redirectToChatApp() {
    if (!this.shopGuid) {
      console.error('Could not get shopGuid');
      return;
    }

    const usuario = this.userEmail;
    const sub = this.userDetails?.sub;
    const family_name = this.userDetails.family_name;
    const given_name = this.userDetails.given_name;
    const fecha = new Date().getTime();
    const origin = window.location.href;
    const token = btoa(`${usuario}:${fecha}:${this.shopId}:${this.shopGuid}:${sub}:${family_name}:${given_name}`);
    const redirectUrl = `${this.chatAppBaseUrl}/auth?t=${token}&origin=${encodeURIComponent(origin)}`;
    window.location.href = redirectUrl;
  }
}
